import React from 'react';
import classNames from 'classnames';

import 'app/assets/stylesheets/design_system/content_section.scss';

type ContentSectionProps = {
  heading: string;
  ctas?: React.ReactNode;
  grid?: boolean;
  subgrid?: boolean;
};

export const ContentSection: React.FC<
  React.PropsWithChildren<ContentSectionProps>
> = ({ heading, ctas, children, subgrid, grid }) => (
  <div
    className={classNames(
      'ds2-5-content-section',
      grid && 'ds2-5-content-section--grid',
    )}
  >
    <div className="ds2-5-content-section__heading">
      <h2 className="ds2-5-content-section__heading__text">{heading}</h2>
    </div>
    <div
      className={classNames(
        'ds2-5-content-section__main',
        subgrid && 'ds2-5-content-section--subgrid',
      )}
    >
      <div className="ds2-5-content-section__main__content">{children}</div>
      {ctas && <div className="ds2-5-content-section__main__ctas">{ctas}</div>}
    </div>
  </div>
);
